// extracted by mini-css-extract-plugin
module.exports = {"root":"cmp-Minicart__body__root"};